import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { TfaGuard } from './core/guard/tfa.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { ChangePasswordComponent } from './views/pages/auth/change-password/change-password.component';
import { OsvReportComponent } from './views/pages/osv-report/osv-report.component';
import { CustomerBlockComponent } from './views/pages/customers/customer-block/customer-block.component';


import { IraReportComponent } from './views/pages/ira-report/ira-report.component';
import { PepReportComponent } from './views/pages/pep-report/pep-report.component';
import { MerchantComplianceComponent } from './views/pages/merchant-compliance/merchant-compliance.component';
import { UserManualComponent } from './views/pages/user-manual/user-manual.component';
import { IntegrationKitComponent } from './views/pages/integration-kit/integration-kit.component';
import { RealTimeRiskMonitorComponent } from './views/pages/real-time-risk-monitor/real-time-risk-monitor.component';
import { ChargeBackComponent } from './views/pages/charge-back/charge-back.component';
import { MerchantReportComponent } from './views/pages/merchant-report/merchant-report.component';
import { FuiIndiaReportComponent } from './views/pages/fui-india-report/fui-india-report.component';
import { RiskAndMonitoringComponent } from './views/pages/risk-and-monitoring/risk-and-monitoring.component';
import { GrievanceReportComponent } from './views/pages/grievance-report/grievance-report.component';
import { NegativeMerchantComponent } from './views/pages/negative-merchant/negative-merchant.component';
import { GrievanceEditComponent } from './views/pages/grievance-report/grievance-edit/grievance-edit.component';
import { PassportCheckComponent } from './views/pages/passport-check/passport-check.component';
import { DocumentsComponent } from './views/pages/documents/documents.component';
//import { ResellerMasterComponent } from './views/pages/reseller/reseller-master/reseller-master.component';
//import { ResellerMasterComponent } from './views/pages/reseller/reseller-master/reseller-master.component';
import { SubmittedBatchComponent } from './views/pages/submitted-batch/submitted-batch.component';
import { MismatchreportComponent } from './views/pages/mismatchreport/mismatchreport.component';
import { PassportcheckImageComponent } from './views/pages/passportcheck-image/passportcheck-image.component';
import { LeadreportComponent } from './views/pages/leadreport/leadreport.component';
import { LeadmasterlistComponent } from './views/pages/leadmasterlist/leadmasterlist.component';
import { CustomerMasterComponent } from './views/pages/customers/customer-master/customer-master.component';
import { CustomerApproveComponent } from './views/pages/customers/customer-approve/customer-approve.component';
import { CustomerEditComponent } from './views/pages/customers/customer-edit/customer-edit.component';
import { CustomerTransactionReportComponent } from './views/pages/customers/customer-transaction-report/customer-transaction-report.component';
import { CustomerWalletLedgerComponent } from './views/pages/customers/customer-wallet-ledger/customer-wallet-ledger.component';
import { CustomerReconciliationReportComponent } from './views/pages/customers/customer-reconciliation-report/customer-reconciliation-report.component';
import { ScreeningUtilityComponent } from './views/pages/screening-utility/screening-utility.component';
import { ScreeningUtilityAddComponent } from './views/pages/screening-utility/screening-utility-add/screening-utility-add.component';
import { ScreeningUtilityEditComponent } from './views/pages/screening-utility/screening-utility-edit/screening-utility-edit.component';
import { VelocityCheckComponent } from './views/pages/velocity-check/velocity-check.component';
import { BlockEntityManagementComponent } from './views/pages/block-entity-management/block-entity-management.component';
import { ReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/reconciliation-report.component';
import { AgentReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/agent-reconciliation-report/agent-reconciliation-report.component';
import { CustomerWiseReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/customer-wise-reconciliation-report/customer-wise-reconciliation-report.component';
import { RiskAssessmentReportComponent } from './views/pages/velocity-check/risk-assessment-report/risk-assessment-report.component';
import { NameScreeningReportComponent } from './views/pages/velocity-check/name-screening-report/name-screening-report.component';
import { BaselCountryReportComponent } from './views/pages/velocity-check/basel-country-report/basel-country-report.component';
import { ProductAddComponent } from './views/pages/product-management/product-add/product-add.component';
import { ProductEditComponent } from './views/pages/product-management/product-edit/product-edit.component';
import { ProductManagementComponent } from './views/pages/product-management/product-management.component';
import { ProductCategoryManagementComponent } from './views/pages/product-category-management/product-category-management.component';
import { ProductCategoryAddComponent } from './views/pages/product-category-management/product-category-add/product-category-add.component';
import { ProductCategoryEditComponent } from './views/pages/product-category-management/product-category-edit/product-category-edit.component';
import { ProductSubcategoryManagementComponent } from './views/pages/product-subcategory-management/product-subcategory-management.component';
import { ProductSubcategoryAddComponent } from './views/pages/product-subcategory-management/product-subcategory-add/product-subcategory-add.component';
import { ProductSubcategoryEditComponent } from './views/pages/product-subcategory-management/product-subcategory-edit/product-subcategory-edit.component';
import { ServiceProviderManagementComponent } from './views/pages/service-provider-management/service-provider-management.component';
import { ServiceProviderAddComponent } from './views/pages/service-provider-management/service-provider-add/service-provider-add.component';
import { ServiceProviderEditComponent } from './views/pages/service-provider-management/service-provider-edit/service-provider-edit.component';
import { ExchangeRatesComponent } from './views/pages/exchange-rates/exchange-rates.component';
import { ExpiredPageComponent } from './views/pages/auth/expired-page/expired-page.component';
import { ExchangeRateEditComponent } from './views/pages/exchange-rates/exchange-rate-edit/exchange-rate-edit.component';
import { CommissionProfileMasterComponent } from './views/pages/commission-profile-master/commission-profile-master.component';
import { CommissionProfileAddComponent } from './views/pages/commission-profile-master/commission-profile-add/commission-profile-add.component';
import { CommissionProfileEditComponent } from './views/pages/commission-profile-master/commission-profile-edit/commission-profile-edit.component';
import { TransactionMasterRuleComponent } from './views/pages/fraud-prevention/transaction-master-rule/transaction-master-rule.component';
import { CountryMasterRuleComponent } from './views/pages/fraud-prevention/country-master-rule/country-master-rule.component';
import { ScreeningConfigurationComponent } from './views/pages/screening-utility/screening-configuration/screening-configuration.component';
import { AuditTrailComponent } from './views/pages/audit-trail/audit-trail.component';
import { MerchantScreeningComponent } from './views/pages/merchants/merchant-master/merchant-screening/merchant-screening.component';
import { TestPageComponent } from './views/pages/screening-utility/test-page/test-page.component';
import { SmartRouterComponent } from './views/pages/smart-router/smart-router.component';
import { OnboardingComponent } from './views/pages/merchants/merchant-master/onboarding/onboarding.component';
import { MerchantTransactionReportComponent } from './views/pages/merchant-transaction-report/merchant-transaction-report.component';
import { CmaStatementReportComponent } from './views/pages/cma-statement-report/cma-statement-report.component';
import { SettlementReportComponent } from './views/pages/settlement-report/settlement-report.component';
import { MerchantAccountComponent } from './views/pages/payment-gateway/merchant-account/merchant-account.component';
import { MerchantAccountEditComponent } from './views/pages/payment-gateway/merchant-account-edit/merchant-account-edit.component';
import { MerchantMappingComponent } from './views/pages/payment-gateway/merchant-mapping/merchant-mapping.component';
import { TdrSettingComponent } from './views/pages/payment-gateway/tdr-setting/tdr-setting.component';
import { RuleEngineComponent } from './views/pages/payment-gateway/rule-engine/rule-engine.component';
import { DocumentComponent } from './views/pages/document/document.component';
import { FrmComponent } from './views/pages/payment-gateway/frm/frm.component';
import { QrCodeGenerationComponent } from './views/pages/qr-code-generation/qr-code-generation.component';
import { CustomerDashboardComponent } from './views/pages/user-dashboard/customer-dashboard/customer-dashboard.component';
import { MerchantDashboardComponent } from './views/pages/user-dashboard/merchant-dashboard/merchant-dashboard.component';
import { LedgerOnlyComponent } from './views/pages/super-transactions/ledger-only/ledger-only.component';
import { LedgerBankComponent } from './views/pages/super-transactions/ledger-bank/ledger-bank.component';
import { SuperTransactionListComponent } from './views/pages/super-transactions/super-transaction-list/super-transaction-list.component';
import { CustomerEventComponent } from './views/pages/customers/customer-event/customer-event.component';
import { TfaSetupComponent } from './views/pages/auth/tfa-setup/tfa-setup.component';
import { TfaVerifyComponent } from './views/pages/auth/tfa-verify/tfa-verify.component';
import { UserActivityComponent } from './views/pages/user-activity/user-activity.component';
import { OnholdTransactionReportComponent } from './views/pages/onhold-transaction-report/onhold-transaction-report.component';
import { DeveloperReportComponent } from './views/pages/developer-report/developer-report.component';
import { VatInvoiceComponent } from './views/pages/vat-invoice/vat-invoice.component';
import { RemittanceEarningReportComponent } from './views/pages/remittance-reports/remittance-earning-report/remittance-earning-report.component';
import { MerchantMasterComponent } from './views/pages/merchants/merchant-master/merchant-master.component';
import { ViewHierarchyComponent } from './views/pages/view-hierarchy/view-hierarchy.component';
import { CustomerRemittanceReportComponent } from './views/pages/remittance-reports/customer-remittance-report/customer-remittance-report.component';
//import { LeadReportComponent } from './views/pages/lead-report/lead-report.component';
//import { MerchantSummaryComponent } from './views/pages/merchant-summary/merchant-summary.component';
import {CrossBorderTransactionReportComponent} from "./views/pages/fx-report/cross-border-transaction-report/cross-border-transaction-report.component";
import { MerchantWithdrawlReportComponent } from './views/pages/merchant-withdrawl-report/merchant-withdrawl-report.component';
import { TransactionReportComponent } from './views/pages/transaction/transaction-report/all/transaction-report.component';
import { WalletReportComponent } from './views/pages/transaction/wallet-report/wallet-report.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
    data: { breadcrumb: { alias: 'Parent' } },
  },
  {
    path: 'auth/tfa-verify',
    component: TfaVerifyComponent,
    data: { bypassAuth: true },
  },
  {
    path: 'auth/tfa-setup',
    component: TfaSetupComponent,
    canActivate: [AuthGuard, TfaGuard],
    data: { bypassAuth: true },
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard, TfaGuard],
    data: { breadcrumb: { alias: 'General' } },
    children: [
      {
        path: 'change-password',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ChangePasswordComponent,
      },
      {
        path: 'general',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'General' } },
        loadChildren: () =>
          import('./views/pages/general/general.module').then(
            (m) => m.GeneralModule
          ),
      },

      /**
       * Commented to avoid duplication - remove once tested - Zubair
       */
      // {
      //   path: 'reseller',
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: {alias: 'Reseller Setup'} },
      //   loadChildren: () => import('./views/pages/resellers/resellers.module').then(m => m.MerchantsModule)
      // },
      /**
       * Commented to avoid duplication - remove once tested - Zubair
       */
      {
        path: 'merchants',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Merchant Setup' } },
        loadChildren: () =>
          import('./views/pages/merchants/merchants.module').then(
            (m) => m.MerchantsModule
          ),
      },

      {
        path: 'pep',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Merchant Setup' } },
        loadChildren: () =>
          import('./views/pages/pep/pep.component').then((m) => m.PepComponent),
      },

      {
        path: 'pepReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: PepReportComponent,
      },

      {
        path: 'negativeMerchant',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: NegativeMerchantComponent,
      },

      {
        path: 'osvReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: OsvReportComponent,
      },
      {
        path: 'iarReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: IraReportComponent,
      },

      {
        path: 'merchantCompliance',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MerchantComplianceComponent,
      },

      {
        path: 'userManual',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: UserManualComponent,
      },

      {
        path: 'integrationKit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: IntegrationKitComponent,
      },

      {
        path: 'realTimeRiskMonitor',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: RealTimeRiskMonitorComponent,
      },
      {
        path: 'chargeBack',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ChargeBackComponent,
      },
      {
        path: 'merchantReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MerchantReportComponent,
      },
      {
        path: 'fiuReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: FuiIndiaReportComponent,
      },
      {
        path: 'riskMonitor',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: RiskAndMonitoringComponent,
      },
      {
        path: 'grievanceReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: GrievanceReportComponent,
      },

      {
        path: 'grievanceEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: GrievanceEditComponent,
      },
      {
        path: 'passportCheckNumber',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: PassportCheckComponent,
      },
      {
        path: 'documents',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: DocumentsComponent,
      },
      {
        path: 'submittedBatch',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: SubmittedBatchComponent,
      },
      {
        path: 'mismatchReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MismatchreportComponent,
      },
      {
        path: 'passportCheckImage',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: PassportcheckImageComponent,
      },
      {
        path: 'customerMaster',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerMasterComponent,
      },
      {
        path: 'customerApprove',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerApproveComponent,
      },
      {
        path: 'customerEvent',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerEventComponent,
      },
      {
        path: 'UserActivity',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: UserActivityComponent,
      },
      {
        path: 'customerEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerEditComponent,
      },
      {
        path: 'customerTransactionReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerTransactionReportComponent,
      },
      {
        path: 'customerWalletLedger',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Wallet Ledger Report' } },
        component: CustomerWalletLedgerComponent,
      },
      {
        path: 'customerReconciliationReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerReconciliationReportComponent,
      },
      {
        path: 'screeningUtility',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ScreeningUtilityComponent,
      },
      {
        path: 'addScreeningUtility',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ScreeningUtilityAddComponent,
      },
      {
        path: 'screeningUtilityEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ScreeningUtilityEditComponent,
      },
      {
        path: 'velocityCheck',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: VelocityCheckComponent,
      },
      {
        path: 'customerBlocked',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerBlockComponent,
      },
      {
        path: 'blockedEntity',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: BlockEntityManagementComponent,
      },

      {
        path: 'userManagement',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'User Management' } },
        loadChildren: () =>
          import('./views/pages/user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
      },

      {
        path: 'reconReport/agentReconReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: AgentReconciliationReportComponent,
      },
      {
        path: 'crossBorderReport',
        canActivate: [AuthGuard],
        data: {breadcrumb: {alias: 'Change Password'}},
        component: CrossBorderTransactionReportComponent
      },
      {
        path: 'reconReport/agentReconReport/customerReconReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CustomerWiseReconciliationReportComponent,
      },
      {
        path: 'riskAssessment',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: RiskAssessmentReportComponent,
      },
      {
        path: 'nameScreeningRule',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: NameScreeningReportComponent,
      },
      {
        path: 'baselCountryRule',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: BaselCountryReportComponent,
      },
      {
        path: 'productManagement/productList',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductManagementComponent,
      },
      {
        path: 'productManagement/productAdd',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductAddComponent,
      },
      {
        path: 'productManagement/productEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductEditComponent,
      },
      {
        path: 'productCategory/productCategoryList',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductCategoryManagementComponent,
      },
      {
        path: 'productCategory/productCategoryAdd',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductCategoryAddComponent,
      },
      {
        path: 'productCategory/productCategoryEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductCategoryEditComponent,
      },
      {
        path: 'productSubcategory/productSubcategoryList',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductSubcategoryManagementComponent,
      },
      {
        path: 'productSubcategory/productSubcategoryAdd',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductSubcategoryAddComponent,
      },
      {
        path: 'productSubcategory/productSubcategoryEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ProductSubcategoryEditComponent,
      },
      {
        path: 'serviceProviderList',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ServiceProviderManagementComponent,
      },
      {
        path: 'serviceProvider/serviceProviderAdd',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ServiceProviderAddComponent,
      },
      {
        path: 'serviceProvider/serviceProviderEdit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ServiceProviderEditComponent,
      },
      {
        path: 'exchangeRates',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ExchangeRatesComponent,
      },
      {
        path: 'exchangeRates/Edit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ExchangeRateEditComponent,
      },
      {
        path: 'commissionProfile',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CommissionProfileMasterComponent,
      },
      {
        path: 'commissionProfile/Add',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CommissionProfileAddComponent,
      },
      {
        path: 'commissionProfile/Edit',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CommissionProfileEditComponent,
      },
      {
        path: 'transactionMasterRule',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: TransactionMasterRuleComponent,
      },
      {
        path: 'countryMasterRule',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: CountryMasterRuleComponent,
      },
      {
        path: 'screeningConfiguration',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: ScreeningConfigurationComponent,
      },
      {
        path: 'auditTrail',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: AuditTrailComponent,
      },
      {
        path: 'merchantScreening',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MerchantScreeningComponent,
      },
      {
        path: 'testPage',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: TestPageComponent,
      },
      {
        path: 'smartRouter',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: SmartRouterComponent,
      },
      {
        path: 'merchants/new-onboarding',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: OnboardingComponent,
      },
      {
        path: 'merchantTransactionReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MerchantTransactionReportComponent,
      },
      {
        path: 'transactionReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Transaction Report' } },
        component: TransactionReportComponent,
      },

      {
        path: 'walletBalanceReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Wallet Balance Report' } },
        component: WalletReportComponent,
      },

      {
        path: 'merchantWithDrawalReport',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Change Password' } },
        component: MerchantWithdrawlReportComponent,
      },
      {
        path: 'resellers',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Reseller Onboarding' } },
        loadChildren: () =>
          import('./views/pages/reseller-setup/reseller-setup.module').then(
            (m) => m.ResellerSetupModule
          ),
      },
      {
        path: 'cma-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: CmaStatementReportComponent,
      },
      {
        path: 'settlement-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: SettlementReportComponent,
      },
      {
        path: 'merchant-account',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: MerchantAccountComponent,
      },
      {
        path: 'merchants/edit-account/:payId',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: MerchantAccountEditComponent,
      },
      {
        path: 'merchant-mapping',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: MerchantMappingComponent,
      },
      {
        path: 'tdr-setting',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: TdrSettingComponent,
      },
      {
        path: 'rule-engine',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: RuleEngineComponent,
      },

      {
        path: 'document-upload',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: DocumentComponent,
      },
      {
        path: 'frm-rule',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: FrmComponent,
      },
      {
        path: 'smart-router',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: SmartRouterComponent,
      },
      {
        path: 'crashing',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'crashing' } },
        loadChildren: () =>
          import('./views/pages/crashing/crashing.module').then(
            (m) => m.CrashingModule
          ),
      },
      {
        path: 'static-qr',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: QrCodeGenerationComponent,
      },
      {
        path: 'customer-dashboard',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: CustomerDashboardComponent,
      },
      {
        path: 'merchant-dashboard',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: MerchantDashboardComponent,
      },
      {
        path: 'super-transactions/ledger-only',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: LedgerOnlyComponent,
      },
      // Add these routes to your auth routes section

      {
        path: 'super-transactions/ledger-bank',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: LedgerBankComponent,
      },
      {
        path: 'super-transactions',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: SuperTransactionListComponent,
      },
      {
        path: 'onhold-transactions-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: OnholdTransactionReportComponent,
      },
      {
        path: 'developer-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: DeveloperReportComponent,
      },
      {
        path: 'vat-invoice',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: VatInvoiceComponent,
      },

      {
        path: 'remittance-earning-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Remittance Earning Report' } },
        component: RemittanceEarningReportComponent,
      },
      {
        path: 'customer-remittance-report',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'report' } },
        component: CustomerRemittanceReportComponent
      },

      {
        path: 'create-hierarchy',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'Create Hierarchy' } },
        loadChildren: () =>
          import('./views/pages/link-merchant/link-merchant.module').then(
            (m) => m.LinkMerchantModule
          ),
      },
      {
        path: 'view-hierarchy',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'View Hierarchy' } },
       component: ViewHierarchyComponent,
      },
      {
        path: 'user-management-new',
        canActivate: [AuthGuard],
        data: { breadcrumb: { alias: 'User Management' } },
        loadChildren: () =>
          import(
            './views/pages/user-management-new/user-management-new.module'
          ).then((m) => m.UserManagementNewModule),
      },
      {
        path: 'user-configuration-new',
        redirectTo: 'user-management-new/user-configuration',
      },
      {
        path: 'role-management-new',
        redirectTo: 'user-management-new/role-management',
      },
      {
        path: 'group-management-new',
        redirectTo: 'user-management-new/group-management',
      },
      {
        path: 'master-tree',
        redirectTo: 'user-management-new/master-tree',
      },
      // {
      //   path: 'leadReport',
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: {alias: 'Change Password'} },
      //   component: LeadreportComponent
      // },
      // {
      //   path: 'leadReportmaster',
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: {alias: 'Change Password'} },
      //   component: LeadmasterlistComponent
      // },
      // {
      //   path: 'merchantSummary',
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: {alias: 'Change Password'} },
      //   component: MerchantSummaryComponent
      // },

      // {
      //   path: 'PassportcheckImageComponent',
      //   data:{breadcrumb: {alias: 'Reseller Setup'}},
      //   component: ResellerMasterComponent,
      //   pathMatch:'full'
      // },
      // {
      //   path: 'reseller',
      // //  canActivate: [AuthGuard],
      //   data: { breadcrumb: {alias: 'Reseller  Setup'} },
      //  // loadChildren: () => import('./views/pages/merchants/merchants.module').then(m => m.MerchantsModule)
      //  component:TestComponent,
      //  pathMatch:'full'
      // },
      { path: '', redirectTo: 'general', pathMatch: 'full' },
    ],
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: "Oopps!! The page you were looking for doesn't exist.",
    },
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {}
}
